@if (!authenticated()) {
<main class="portal">
  <header class="topbar">
    <a class="brand" href="/" aria-label="Accueil Medicarelee">
      <span class="brand-sign"><app-ui-icon name="brand" /></span>
      <span>medicarelee</span>
    </a>
    <div class="topbar-actions">
      <a class="support" href="tel:+2250000000000"><app-ui-icon name="support" /> Assistance</a>
      <button class="language" type="button" aria-label="Changer de langue"><app-ui-icon name="globe" /><span>FR</span></button>
    </div>
  </header>

  <section class="content">
    <div class="access-panel">
      @if (viewMode() === 'spaces') {
        <div class="access-copy selection-copy">
          <p class="overline">Bienvenue</p>
          <h1>Choisissez votre espace.</h1>
          <p>Chaque profil dispose d’un environnement dédié, avec uniquement les outils utiles à son activité.</p>
        </div>
        <section class="space-grid" aria-label="Choisir un espace de connexion">
          @for (space of spaces; track space.value; let index = $index) {
            <button type="button" (click)="selectSpace(space.value)">
              <span class="space-number">0{{ index + 1 }}</span>
              <span class="space-icon"><app-ui-icon [name]="space.icon" /></span>
              <strong>{{ space.label }}</strong>
              <small>{{ space.description }}</small>
              <app-ui-icon class="space-arrow" name="arrow" />
            </button>
          }
          <button class="space-wide" type="button" (click)="openOtherSpaces()">
            <span class="space-number">03</span><span class="space-icon"><app-ui-icon name="manager" /></span>
            <strong>Autre</strong><small>Gestionnaire, garant ou souscripteur</small><app-ui-icon class="space-arrow" name="arrow" />
          </button>
        </section>
      } @else if (viewMode() === 'other') {
        <div class="access-copy selection-copy"><p class="overline">Autres espaces</p><h1>Précisez votre profil.</h1><p>Accédez à l’environnement correspondant à votre organisation.</p></div>
        <button class="back-action other-back" type="button" (click)="backToSpaces()">← Retour</button>
        <section class="space-grid other-grid" aria-label="Choisir un autre espace">
          @for (space of otherSpaces; track space.value; let index = $index) {
            <button type="button" (click)="selectSpace(space.value)"><span class="space-number">0{{ index + 1 }}</span><span class="space-icon"><app-ui-icon [name]="space.icon" /></span><strong>{{ space.label }}</strong><small>{{ space.description }}</small><app-ui-icon class="space-arrow" name="arrow" /></button>
          }
        </section>
      } @else {
        <div class="access-copy login-copy">
          <p class="overline">Espace {{ selectedSpaceLabel() }}</p>
          <h1>Heureux de vous revoir.</h1>
          <p>Connectez-vous pour retrouver vos opérations et informations.</p>
        </div>
      }

      @if (viewMode() === 'login' && loginForm.controls.origine.value === 'BENEFICIAIRE') {
      <form class="login-form simplified-form" [formGroup]="simplifiedLoginForm" (ngSubmit)="submitSimplifiedLogin()" novalidate>
        <button class="back-action" type="button" (click)="backToSpaces()">← Changer d’espace</button>
        <p class="simplified-hint">Entrez votre matricule et votre date de naissance. Pas de mot de passe à retenir.</p>

        <label for="benef-matricule">Numéro matricule</label>
        <input id="benef-matricule" formControlName="matricule" type="text" inputmode="numeric" autocomplete="off" placeholder="Votre matricule" />

        <label for="benef-date-naissance">Date de naissance</label>
        <input id="benef-date-naissance" formControlName="dateNaissance" type="date" autocomplete="off" />

        @if (errorMessage()) { <p class="form-message error" role="alert">{{ errorMessage() }}</p> }

        <button class="submit" type="submit" [disabled]="loading()">
          {{ loading() ? 'Connexion en cours…' : 'Continuer' }}
          <app-ui-icon name="arrow" />
        </button>
      </form>
      } @else if (viewMode() === 'login') {
      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="submit()" novalidate>
        <button class="back-action" type="button" (click)="backToSpaces()">← Changer d’espace</button>
        <label for="identifier">Identifiant</label>
        <input id="identifier" formControlName="identifier" type="text" autocomplete="username" placeholder="Votre identifiant" />

        <div class="password-label">
          <label for="password">Mot de passe</label>
          <a href="/mot-de-passe-oublie">Mot de passe oublié ?</a>
        </div>
        <input id="password" formControlName="password" type="password" autocomplete="current-password" placeholder="Votre mot de passe" />

        @if (errorMessage()) { <p class="form-message error" role="alert">{{ errorMessage() }}</p> }
        @if (successMessage()) { <p class="form-message success" role="status">{{ successMessage() }}</p> }

        <button class="submit" type="submit" [disabled]="loading()">
          {{ loading() ? 'Connexion en cours…' : 'Se connecter' }}
          <app-ui-icon name="arrow" />
        </button>
      </form>
      }

      <footer>
        <span class="secure"><app-ui-icon name="shield" /> Connexion sécurisée</span>
        <span class="environment">{{ environmentName }}</span>
      </footer>
    </div>

    <aside class="context-panel">
      <div class="context-index">01 <span>/ 03</span></div>
      <div class="context-copy">
        <p class="context-kicker">Une plateforme. Plusieurs espaces.</p>
        <h2>L’information utile au bon moment.</h2>
        <p>Assurés, prestataires et partenaires accèdent uniquement aux outils adaptés à leur activité.</p>
      </div>
      <nav class="profiles" aria-label="Profils disponibles">
        <button type="button" [class.active]="loginForm.controls.origine.value === 'BENEFICIAIRE'" (click)="selectSpace('BENEFICIAIRE')">Assuré</button>
        <button type="button" [class.active]="loginForm.controls.origine.value === 'PRESTATAIRE'" (click)="selectSpace('PRESTATAIRE')">Prestataire</button>
        <button type="button" [class.active]="viewMode() === 'other' || ['GARANT','GESTIONNAIRE','SOUSCRIPTEUR'].includes(loginForm.controls.origine.value)" (click)="openOtherSpaces()">Autre</button>
      </nav>
      <div class="signature">Santé · confiance · proximité</div>
    </aside>
  </section>
</main>
} @else {
  <router-outlet />
}
